<template>
  <Layout>
    <v-row>
      <v-col class="d-flex justify-start">
        <v-btn elevation="2" @click="goBack"> ย้อนกลับ </v-btn>
      </v-col>
    </v-row>
    <br />
    <v-card elevation="2" outlined shaped tile class="px-2 py-2">
      <v-card-title>
        แก้ไขรายการนับสินค้าของสาขา {{ storeSelectName }}
      </v-card-title>

      <template v-if="loading">
        <v-skeleton-loader
          v-bind="attrs"
          type="article, actions"
        ></v-skeleton-loader
      ></template>
      <template v-else>
        <v-form v-model="valid" @submit.prevent="submit">
          <v-container>
            <div class="heading-form">วัน-เวลาในการนับสินค้า</div>

            <v-row>
              <v-col cols="12" lg="8">
                <v-dialog
                  v-model="modal"
                  ref="dialog"
                  persistent
                  disabled
                  width="290px"
                >
                  <template v-slot:activator="{ attrs }">
                    <v-combobox
                      v-model="dates"
                      v-bind="attrs"
                      label="วันที่"
                      placeholder="กรอกวันที่ตามด้วย ,(comma) เพื่อใส่วันที่ต่อไป"
                      chips
                      multiple
                      outlined
                      hide-details
                      disabled
                      :delimiters="[',', ' ']"
                    >
                      <template v-slot:append>
                        <v-icon class="mr-2" color="grey">
                          mdi-calendar
                        </v-icon>
                      </template>
                      <template
                        v-slot:selection="{
                          attrs,
                          item,
                          select,
                          selected,
                        }"
                      >
                        <v-chip
                          v-bind="attrs"
                          small-chips
                          disabled
                          :input-value="selected"
                          @click="select"
                          @click:close="remove(item)"
                        >
                          {{ item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </template>
                </v-dialog>
              </v-col>
            </v-row>

            <v-row align="center" class="mb-2">
              <v-col cols="12" lg="8">
                <v-row align="center">
                  <v-col cols="5" sm="2">
                    <v-select
                      v-model="fromHH"
                      :items="hours"
                      label="ชั่วโมง"
                      disabled
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="5" sm="2">
                    <v-select
                      v-model="fromMM"
                      :items="minutes"
                      label="นาที"
                      disabled
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="auto" sm="1" class="mb-sm-4">
                    ถึง
                  </v-col>
                  <v-col cols="5" sm="2">
                    <v-select
                      v-model="endHH"
                      :items="hours2"
                      label="ชั่วโมง"
                      disabled
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="5" sm="2">
                    <v-select
                      v-model="endMM"
                      :items="minutes"
                      label="นาที"
                      disabled
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <div class="heading-form">เลือกสาขา</div>
            <v-row>
              <v-col cols="12" lg="8">
                <v-autocomplete
                  v-model="selectStore"
                  :items="storeData"
                  disabled
                  chips
                  small-chips
                  label="สาขา"
                  item-text="store_name"
                  item-value="store_id"
                  multiple
                  outlined
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <div class="heading-form">เลือกแบรนด์</div>
            <v-row>
              <v-col cols="12" lg="8">
                <div class="select-container">
                  <v-autocomplete
                    v-model="selectBrand"
                    :items="brands"
                    chips
                    small-chips
                    label="แบรนด์"
                    multiple
                    outlined
                    hide-details
                  >
                    <template
                      v-if="brands.length > 0"
                      v-slot:prepend-item
                    >
                      <v-list-item>
                        <v-list-item-title>
                          <v-checkbox
                            :label="`เลือกแบรนด์ทั้งหมด (${brands.length} แบรนด์)`"
                            :value="
                              selectBrand.length === brands.length
                            "
                            :indeterminate="
                              selectBrand.length > 0 &&
                              selectBrand.length < brands.length
                            "
                            class="my-0"
                            hide-details
                            @click.stop="
                              selectBrand =
                                selectBrand.length === brands.length
                                  ? []
                                  : brands.slice()
                            "
                          ></v-checkbox>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <v-btn depressed @click="selectBrand = []">
                    ล้างแบรนด์
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <div class="heading-form">หมวดหมู่</div>
            <v-row align="center">
              <v-col cols="12" lg="8">
                <div class="select-container">
                  <v-autocomplete
                    v-model="selectCategory"
                    :items="categories"
                    chips
                    small-chips
                    label="หมวดหมู่"
                    multiple
                    outlined
                    hide-details
                  >
                    <template
                      v-if="categories.length > 0"
                      v-slot:prepend-item
                    >
                      <v-list-item>
                        <v-list-item-title>
                          <v-checkbox
                            :label="`เลือกหมวดหมู่ทั้งหมด (${categories.length} หมวดหมู่)`"
                            :value="
                              selectCategory.length ===
                              categories.length
                            "
                            :indeterminate="
                              selectCategory.length > 0 &&
                              selectCategory.length <
                                categories.length
                            "
                            class="my-0"
                            hide-details
                            @click.stop="
                              selectCategory =
                                selectCategory.length ===
                                categories.length
                                  ? []
                                  : categories.slice()
                            "
                          ></v-checkbox>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <v-btn depressed @click="selectCategory = []">
                    ล้างหมวดหมู่
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <div class="heading-form">หมวดหมู่ย่อย</div>
            <v-row class="py-2">
              <v-col cols="12" lg="8">
                <div class="select-container">
                  <v-autocomplete
                    v-model="selectSubCategory"
                    :items="subCategories"
                    chips
                    small-chips
                    label="หมวดหมู่ย่อย"
                    multiple
                    outlined
                    hide-details
                  >
                    <template
                      v-if="subCategories.length > 0"
                      v-slot:prepend-item
                    >
                      <v-list-item>
                        <v-list-item-title>
                          <v-checkbox
                            :label="`เลือกหมวดหมู่ย่อยทั้งหมด (${subCategories.length} หมวดหมู่ย่อย)`"
                            :value="
                              selectSubCategory.length ===
                              subCategories.length
                            "
                            :indeterminate="
                              selectSubCategory.length > 0 &&
                              selectSubCategory.length <
                                subCategories.length
                            "
                            class="my-0"
                            hide-details
                            @click.stop="
                              selectSubCategory =
                                selectSubCategory.length ===
                                subCategories.length
                                  ? []
                                  : subCategories.slice()
                            "
                          ></v-checkbox>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  <v-btn depressed @click="selectSubCategory = []">
                    ล้างหมวดหมู่ย่อย
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <div class="heading-form">โปรดักโค้ด (SKU)</div>
            <v-row>
              <v-col cols="12" lg="8">
                <v-combobox
                  label="โปรดักโค้ด"
                  v-model="skus"
                  :delimiters="[',']"
                  chips
                  clearable
                  multiple
                  outlined
                  append-icon=""
                >
                  <template
                    v-slot:selection="{
                      attrs,
                      item,
                      select,
                      selected,
                    }"
                  >
                    <v-chip
                      small
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click="select"
                      @click:close="removeSku(item)"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>

            <!-- Submit -->
            <v-btn class="mr-4" @click="submit" color="primary">
              บันทึก
            </v-btn>
            <!-- <v-btn depressed @click="clear"> clear </v-btn> -->
          </v-container>
        </v-form>

        <v-snackbar v-model="toastSuccess" :timeout="2000">
          บันทึกสำเร็จ
          <template v-slot:action="{ attrs }">
            <v-btn
              color="primary"
              text
              v-bind="attrs"
              @click="toastSuccess = false"
            >
              ปิด
            </v-btn>
          </template>
        </v-snackbar>
      </template>
    </v-card>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      me: (state) => state.me.data,
      storeDetail: (state) => state.job.storeDetail,
      storeDetailLoading: (state) => state.job.isLoading,
      storeData: (state) => state.masterData?.store ?? [],
      buData: (state) => state.masterData.bu,
      categoryData: (state) => state.masterData.category,
    }),
    loading() {
      return this.storeDetailLoading
    },
    categories() {
      return (
        this.categoryData?.categories.map((i) => i.category_name) ??
        []
      )
    },
    brands() {
      return this.categoryData?.brands ?? []
    },
    subCategories() {
      const all = this.categoryData?.categories.reduce(
        (subCat, i) => {
          subCat = [...subCat, ...i?.sub_cat]
          // console.log('1=>', subCat?.concat(i?.sub_cat))
          return subCat
        },
        [],
      )
      return all?.filter(
        (value, index, self) => self?.indexOf(value) === index,
      )
    },
    hours() {
      let hh = []
      for (let i = 0; i < 24; i++) {
        i < 10 ? hh.push(`0${i}`) : hh.push(`${i}`)
      }
      return hh
    },
    minutes() {
      let mm = []
      for (let i = 0; i <= 59; i++) {
        i < 10 ? mm.push(`0${i}`) : mm.push(`${i}`)
      }
      return mm
    },
    hours2() {
      let hh = []
      for (let i = +this.fromHH + 1 ?? 0; i < 24; i++) {
        i < 10 ? hh.push(`0${i}`) : hh.push(`${i}`)
      }
      return hh
    },
    jobDetailStoreId() {
      return this?.storeDetail?.[0]?.store_id
    },
    storeSelectName() {
      return (
        this.storeData?.find(
          (i) => i?.store_id === this.selectStore?.[0],
        )?.store_name ?? ''
      )
    },
  },

  components: {
    Layout,
  },

  watch: {
    storeDetail() {
      // Set Default Value from api

      // Store
      const store = [
        {
          store_id: this?.storeDetail?.store_id,
          store_name: this?.storeDetail?.store_name,
          sku: this?.storeDetail?.sku ?? [],
        },
      ]

      this.storeData = store
      this.selectStore = [this?.storeDetail?.store_id]
      this.dates = [this.storeDetail.date]

      this.selectBrand =
        this.storeDetail?.product_brand?.filter(
          (value, index, self) => self?.indexOf(value) === index,
        ) ?? []

      this.selectCategory =
        this.storeDetail?.category?.filter(
          (value, index, self) => self?.indexOf(value) === index,
        ) ?? []

      this.selectSubCategory =
        this.storeDetail?.sub_cat?.filter(
          (value, index, self) => self?.indexOf(value) === index,
        ) ?? []

      this.skus = store
        ?.reduce((acc, i) => {
          return acc?.concat(
            Array.isArray(i?.sku) ? i?.sku : i?.sku?.split(`,`) || [],
          )
        }, [])
        .filter(
          (value, index, self) => self?.indexOf(value) === index,
        )

      this.fromHH =
        '' + this.storeDetail?.start_time?.split(':')[0] ?? ''
      this.fromMM =
        '' + this.storeDetail?.start_time?.split(':')[1] ?? ''
      this.endHH =
        '' + this.storeDetail?.end_time?.split(':')[0] ?? ''
      this.endMM =
        '' + this.storeDetail?.end_time?.split(':')[1] ?? ''
    },
  },

  data() {
    return {
      selectBU: '',
      selectStore: '',
      jobName: this.jobDetailName,
      jobDate: null,
      dates: [],
      menu1: false,
      menu2: false,
      selectCategory: [],
      selectSubCategory: [],
      selectBrand: [],
      fromHH: '',
      fromMM: '',
      endHH: '',
      endMM: '',
      toastSuccess: false,
      skus: [],
    }
  },

  async mounted() {
    const payload = {
      id: this.$route.params.id,
      storeId: this.$route.params.storeId,
    }
    await this.$store.dispatch('job/getStoreDetail', payload)
    this.$store.dispatch('masterData/getBu')
    this.$store.dispatch('masterData/getStore')
    this.$store.dispatch('masterData/getCategory', {
      storeId: this.$route.params.storeId,
    })
  },

  methods: {
    goBack() {
      this.$router.push({
        name: 'JobDetail',
        params: {
          id: this.$route.params.id,
          storeId: this.$route.params.storeId,
        },
      })
    },

    clear() {
      this.jobDate = ''
      this.jobName = ''
      this.dates = []
      this.selectBU = ''
    },

    onChangeBU() {
      this.getCategory()
    },

    onChangeStore() {
      this.getCategory()
    },

    getCategory() {
      this.$store.dispatch('masterData/getCategory', {
        storeId: this.$route.params.storeId,
      })
    },

    async submit() {
      const payload = {
        job_id: this.$route.params.id,
        store_id: this.$route.params.storeId,
        start_time: `${this.fromHH}:${this.fromMM}`,
        end_time: `${this.endHH}:${this.endMM}`,
        'product_brands[]': this.selectBrand,
        'categories[]': this.selectCategory,
        'sub_cats[]': this.selectSubCategory,
        sku: this.skus,
      }
      await this.$store.dispatch('job/updateStoreDetail', payload)
      this.toastSuccess = true
    },

    removeSku(val) {
      this.skus = this.skus.filter((i) => i !== val)
    },
  },
}
</script>

<style lang="stylus" scoped>
.v-list-item__title {
  text-align: left !important;
}
</style>
